export class EnumHelper {
  public static ToArray(enumType) {
    return Object.keys(enumType);
  }
}
